export const SET_DOWNLOAD = "SET_DOWNLOAD";
export const GET_DOWNLOAD = "GET_DOWNLOAD";
export const DELETE_DOWNLAOD = "DELETE_DOWNLOAD";
export const UPDATE_DOWNLOAD = "UPDATE_DOWNLOAD";
export const GET_ONE_DOWNLOAD = "GET_ONE_DOWNLOAD";